import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getSummary() {
        try
        {            
            const response = await axios.get(`Loans`,
            {
                headers: {
                    'page_key': pageKeys.loans
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Loans getSummary api error')
            throw error
        }
    },
    async getMyLoans() {
        try
        {            
            const response = await axios.get(`Loans/myloans`,
            {
                headers: {
                    'page_key': pageKeys.my_loans
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Loans getMyLoans api error')
            throw error
        }
    },
    async get(loanId) {
        try
        {            
            const response = await axios.get(`Loans/${loanId}`,
            {
                headers: {
                    'page_key': pageKeys.loans
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Loans getSummary api error')
            throw error
        }
    },
    async getMyLoanDetail(loanId) {
        try
        {            
            const response = await axios.get(`Loans/${loanId}`,
            {
                headers: {
                    'page_key': pageKeys.my_loans
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Loans getMyLoanDetail api error')
            throw error
        }
    },
    async getSchedule(scheduleId) {
        try
        {            
            const response = await axios.get(`Loans/schedule/${scheduleId}`,
            {
                headers: {
                    'page_key': pageKeys.loans
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Loans getSchedule api error')
            throw error
        }
    },
    async getMyLoansSchedule(scheduleId) {
        try
        {            
            const response = await axios.get(`Loans/schedule/${scheduleId}`,
            {
                headers: {
                    'page_key': pageKeys.my_loans
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Loans getMyLoansSchedule api error')
            throw error
        }
    },
    async getTypes() {
        try
        {            
            const response = await axios.get(`Loans/types`,
            {
                headers: {
                    'page_key': pageKeys.my_loans
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Loans getTypes api error')
            throw error
        }
    },
    async add(data, pageKey) {
        try
        {            
            const response = await axios.post(`Loans`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Loans add api error')
            throw error
        }
    },
    async update(data, pageKey) {
        try
        {            
            const response = await axios.patch(`Loans`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Loans update api error')
            throw error
        }
    },
    async setForReview(data, pageKey) {
        try
        {            
            const response = await axios.post(`Loans/forreview`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('Loans setForReview api error')
            throw error
        }
    },
    async approve(data) {
        try
        {            
            const response = await axios.post(`Loans/approve`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.loans
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('Loans approve api error')
            throw error
        }
    },
    async reject(data) {
        try
        {            
            const response = await axios.post(`Loans/reject`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.loans
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('Loans reject api error')
            throw error
        }
    },
    async setToPaid(data) {
        try
        {            
            const response = await axios.post(`Loans/schedule/paid`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.loans
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('Loans setToPaid api error')
            throw error
        }
    }
}
